import React from 'react';
import { ColumnsType } from 'antd/es/table';
import { Avatar, Space } from 'antd';
import Table from '../../../commonComponents/Table';
import { RecentVisit, RecentCustomersTableProps } from './types';
import { formatDateAndTime } from '../../../utils/formatDateTime';
import { useTheme } from '../../../context/ThemeContext';
import { RankingCard, SectionTitle } from './styles';

const RecentCustomersTable: React.FC<RecentCustomersTableProps> = ({ data = [], loading = false }) => {
  const { isDarkMode } = useTheme();

  const columns: ColumnsType<RecentVisit> = [
    {
      title: 'Customer',
      key: 'customer',
      render: (_, record) => (
        <Space>
          <Avatar size="small">{record.name.charAt(0)}</Avatar>
          <span>{record.name}</span>
        </Space>
      ),
    },
    {
      title: 'Date',
      key: 'date',
      align: 'right',
      render: (_, record) => formatDateAndTime(record.date).formattedDate,
    },
    {
      title: 'Time',
      key: 'time',
      align: 'right',
      render: (_, record) => formatDateAndTime(record.date).formattedTime,
    },
    {
      title: 'Amount Spent ($)',
      key: 'amount',
      align: 'right',
      render: (_, record) => `$${record.amount.toLocaleString()}`,
    },
  ];

  return (
    <RankingCard>
      <SectionTitle level={4}>Recent Customer Visits</SectionTitle>
      <Table<RecentVisit>
        columns={columns}
        dataSource={data}
        rowKey="id"
        loading={loading}
        pagination={false}
        emptyText="No recent visits found"
        scroll={{ x: true }}
        headerBackgroundColor={isDarkMode ? '#2D3748' : '#F7FAFC'}
        removeVerticalBorders={true}
        thPadding="16px 12px"
        tdPadding="16px 12px"
        firstChildBorderRadius="8px"
        border="0"
        borderBottomLeftRight={true}
        theme={isDarkMode ? 'dark' : 'light'}
      />
    </RankingCard>
  );
};

export default RecentCustomersTable;
